import { Role } from "@/interfaces/roles";

// the back does not have a defined string so by default it takes a code "44e1ec68e2a43f32741cbd4cb4d77c79e28d6a5c".
export enum DeleteCode {
  DELETE_CODE = "44e1ec68e2a43f32741cbd4cb4d77c79e28d6a5c"
}

export interface User {
  admin?: boolean;
  avatar_content_type?: string;
  avatar_file_name?: string;
  avatar_file_size?: number;
  avatar_medium_url?: string;
  avatar_original_url?: string;
  avatar_thumb_url?: string;
  avatar_updated_at?: string;
  avatar_variants?: string;
  avatar?: string;
  delete?: boolean;
  device_token?: string;
  device_type?: string;
  email: string;
  first_name?: string;
  hasMetrcConfig?: boolean;
  hasBiotrackConfig?: boolean;
  id: number | null;
  last_login?: string;
  last_name?: string;
  name: string;
  password?: string;
  pin_code: string;
  profile?: Profile;
  redirectTo?: string;
  remember_token?: string;
  roles?: number[] | Role[];
  routeCondition?: string;
  type: string;
  settings?: Setting;
  status?: string;
  updated_by?: string;
  metrc?: {
    expiration: string | null;
    occupational_license_number: string | null;
    user_key: string | null;
  } | null;
  biotrack?: {
    username: string | null;
    password: string | number | null;
  } | null;
  pharmacistData: PharmacistInterface;
  pharmacist?: string;
}

export interface Avatar {
  name?: string;
}
export interface Profile {
  user_id?: number;
  first_name: string;
  middle_name?: string;
  last_name?: string;
  hourly_rate: number | null;
  drivers_license_expiration: string;
  birthday: string;
  phone_number: string;
  company_email_address: string;
  personal_email: string;
  mailing_address: string;
  gender: string;
  nickname: string;
  drivers_license_number: string;
  emergency_contact?: string;
  emergency_contact_number?: string;
  country_id: string | null;
  state_id: number | null;
  city: string;
  zip: string;
}

export interface Setting {
  locale: string;
  current_account_id: number | null;
  current_location_id: number | null;
  preferences?: Preferences;
}

export interface PharmacistInterface {
  user_id: number | null;
  pharmacist_title: string;
  pharmacist_license_number: string;
  pharmacist_national_provider_identifier: string;
  pharmacist_enable: number;
  pharmacist_location: PharmacistLocation;
}
export interface PharmacistLocation {
  add?: number[] | [];
  delete?: number[] | [];
}

export const pharmacistDefault: PharmacistInterface = {
  user_id: 0,
  pharmacist_title: "",
  pharmacist_license_number: "",
  pharmacist_national_provider_identifier: "",
  pharmacist_enable: 0,
  pharmacist_location: {
    add: [],
    delete: []
  }
};

export const userDefault: User = {
  id: null,
  avatar: "",
  name: "",
  email: "",
  password: "",
  pin_code: "",
  settings: {
    locale: "",
    current_account_id: null,
    current_location_id: null
  },
  roles: [],
  type: "",
  profile: {
    nickname: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    birthday: "",
    mailing_address: "",
    city: "",
    state_id: null,
    country_id: null,
    company_email_address: "",
    personal_email: "",
    phone_number: "",
    gender: "",
    drivers_license_number: "",
    drivers_license_expiration: "",
    hourly_rate: null,
    zip: ""
  },
  pharmacistData: pharmacistDefault,
  metrc: {
    expiration: null,
    occupational_license_number: null,
    user_key: null
  },
  biotrack: {
    username: null,
    password: null
  },
  pharmacist: "0"
};

interface Preferences {
  tilesConfig: TilesConfig[];
}

interface TilesConfig {
  h: number;
  i: string;
  w: number;
  x: number;
  y: number;
  moved: boolean;
  visible: boolean;
  timeclock?: boolean;
  dailyLocationActionTickerComponent?: boolean;
  dailyRetailSalesComponent?: boolean;
  dailyFinancialBreakdownComponent?: boolean;
}

export interface PharmacistLocationInterface {
  location_id: number;
  user_id: number;
}
